// extracted by mini-css-extract-plugin
export default {"root":"juqxlK","mobile":"oPxDbe","large":"lXt5dO","thumbnail":"cOXfvl","layout":"q9uiAI"};